import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=2b510fc9&"
import script from "./Sitemap.vue?vue&type=script&lang=ts&"
export * from "./Sitemap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports